import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const ModulePlaceholder = ({ amount = 1 }) => {
  return (
    <div role="alert" aria-busy="true">
      {[...Array(amount)].map((_, index) => (
        <div
          key={index}
          className="flex relative p-4 w-full mb-3 bg-white rounded border border-subdued"
        >
          <div className="flex-grow-0 flex-shrink-0">
            <Shimmer width={36} height={36} rounded />
          </div>
          <div className="ml-4 flex-auto">
            <div>
              <Shimmer className="mb-2" style={{ width: '100%' }} height={16} />
            </div>
            <div className="mb-[8px]">
              <Shimmer style={{ width: '100%' }} height={18} />
            </div>
            <div className="flex -mx-2 mb-4">
              <div className="flex items-center px-2">
                <div className="ml-2">
                  <Shimmer width={36} height={16} />
                </div>
              </div>
              <div className="flex items-center px-2">
                <div className="ml-2">
                  <Shimmer width={36} height={16} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap justify-between -mx-2">
              <div className="flex items-center px-2">
                <Shimmer style={{ width: '100%' }} height={18} />
              </div>
              <div className="px-2">
                <Shimmer width={92} height={18} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ModulePlaceholder
